import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FiservDisplay } from "components";
import Grid from "@mui/material/Grid";

const STYLES = {
  box: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "60vw",
    maxHeight: "90vh",
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    overflowY: 'scroll',
  }
}

const EMPTY_SG = {
  locationNo: null,
  merchantId: null,
  subgroupmId: null,
  submerchantId: null,
  terminals: [],
};


const ShowApplication = ({ merchant, open, handleClose }) => {

  const [submission, setSubmission] = useState({});
  const safeParse = (value) => {
    try {
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    if (!merchant) return;

    setSubmission({
      merchantDetails: safeParse(merchant.merchantDetails),
      tradingLocations: safeParse(merchant.tradingLocations),
      principalDetails: safeParse(merchant.principalDetails),
      uboDetails: safeParse(merchant.uboDetails),
      businessSummary: safeParse(merchant.businessSummary),
      creditApproval: safeParse(merchant.creditApproval),
      ipgProvisioning: safeParse(merchant.ipgProvisioning),
      enquireResponse: safeParse(merchant.enquireResponse),
    });
  }, [merchant]);

  if (!merchant || !open) return null;
  return <Modal
    open={open}
    onClose={handleClose}
  >
    <Box sx={ STYLES.box }>

      {
        submission.enquireResponse && <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontWeight: "bold" }}>Enquiry Status</Typography>

          <Box sx={{ mb: 2 }}>
            <Grid container>
              <Grid item sx={{ color: "gray" }} xs={3}>uwDecision: </Grid>
              <Grid item xs={9}>{ submission.enquireResponse.uwDecision }</Grid>
            </Grid>

            <Grid container>
              <Grid item sx={{ color: "gray" }} xs={3}>comments: </Grid>
              <Grid item xs={9}>{ submission.enquireResponse.comments }</Grid>
            </Grid>

            <Grid container>
              <Grid item sx={{ color: "gray" }} xs={3}>lastUpdatedDate: </Grid>
              <Grid item xs={9}>{ submission.enquireResponse.lastUpdatedDate }</Grid>
            </Grid>

            <Grid container>
              <Grid item sx={{ color: "gray" }} xs={3}>lsgMid: </Grid>
              <Grid item xs={9}>{ submission.enquireResponse.lsgMid }</Grid>
            </Grid>
          </Box>
          <hr />
        </Box>
      }

      {submission.ipgProvisioning && (
        <Box>
          <Typography sx={{ fontWeight: "bold" }}>
            IPG Provisioning Status
          </Typography>

          {submission.ipgProvisioning.ipgStores?.map((item, index) => {
            const { ipgStatus, merchantId, sharedSecret, storeId, terminals } = item;

            return (
              <Grid container key={index} sx={{ mb: 2 }}>
                <Grid item xs={3} sx={{ color: "gray" }}>IPG Status:</Grid>
                <Grid item xs={9}>{ipgStatus}</Grid>

                <Grid item xs={3} sx={{ color: "gray" }}>Merchant ID:</Grid>
                <Grid item xs={9}>{merchantId}</Grid>

                <Grid item xs={3} sx={{ color: "gray" }}>Store ID:</Grid>
                <Grid item xs={9}>{storeId}</Grid>

                <Grid item xs={3} sx={{ color: "gray" }}>Shared Secret:</Grid>
                <Grid item xs={9}>{sharedSecret}</Grid>

                <Grid item xs={3} sx={{ color: "gray" }}>Terminals:</Grid>
                <Grid item xs={9}>
                  <ul>
                    {terminals?.map((t, i) => (
                      <li key={i}>{t}</li>
                    ))}
                  </ul>
                </Grid>
              </Grid>
            );
          })}

          <hr />
        </Box>
      )}

      {<Box sx={{ my: 2 }}>
          <Typography sx={{ fontWeight: "bold" }}>Credit Approval Status</Typography>
          <Box sx={{ mb: 2 }}>
          {
            submission.creditApproval && Object.keys(submission.creditApproval).map((key) => {
              const creditApproval = submission.creditApproval || {};
              if (key === "sgarray") {
                const arr = creditApproval[key] || [];
                for (let item of arr) {
                  const { locationNo, merchantId, subgroupmId, submerchantId, terminals } = item;
                  return <Grid container key={key}>
                      <Grid item style={{ color: "gray" }} xs={12}>&nbsp;</Grid>
                      <Grid item style={{ color: "gray" }} xs={3}>Location No: </Grid><Grid item xs={9}>{locationNo}</Grid>
                      <Grid item style={{ color: "gray" }} xs={3}>Merchant ID: </Grid><Grid item xs={9}>{merchantId}</Grid>
                      <Grid item style={{ color: "gray" }} xs={3}>Subgroup MID: </Grid><Grid item xs={9}>{subgroupmId}</Grid>
                      <Grid item style={{ color: "gray" }} xs={3}>Submerchant ID: </Grid><Grid item xs={9}>{submerchantId}</Grid>
                      <Grid item style={{ color: "gray" }} xs={3}>Terminals: </Grid>
                      <Grid item xs={9}>
                        {
                          terminals.map((terminal, tIndex) => <li key={tIndex}>{ terminal }</li>)
                        }
                      </Grid>
                  </Grid>
                }
              }
              return <Grid container key={key}>
                <Grid item xs={3} sx={{ color: "gray" }}>{ key }:</Grid>
                <Grid item xs={9}>{ submission.creditApproval[key] }</Grid>
              </Grid>
            })
          }
          </Box>

          <hr />
          
        </Box>
      }

      <FiservDisplay 
        name="Merchant Details"
        submission={submission.merchantDetails}
      />
      <FiservDisplay 
        name="Trading Locations"
        submission={submission.tradingLocations}
        type="Location"
      />
      <FiservDisplay 
        name="Principal Owner Details"
        submission={submission.principalDetails}
        type="Principal Owner"
      />
      <FiservDisplay 
        name="UBO Details"
        submission={submission.uboDetails}
        type="UBO"
      />
      <FiservDisplay 
        name="Business Summary"
        submission={submission.businessSummary}
      />
    </Box>
  </Modal>
}

export default ShowApplication;